import React from "react";
import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Polyline,
} from "react-google-maps";
import {
    compose,
    withProps,
    // withStateHandlers,
    lifecycle
} from "recompose";

const googleMapURL = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCC-gpzzG6hcmAyagvaYCc23KAy4rIkv2A&v=3.exp&libraries=geometry,drawing,places,visualization";
const MapUserTrip = compose(
    withProps({
        googleMapURL,
        loadingElement: <div style={{ height: "100%" }}/>,
        containerElement: <div style={{ height: "100%" }}/>,
        mapElement: <div style={{ height: "100%" }}/>,
    }),
    withScriptjs,
    withGoogleMap,

    lifecycle({
        componentDidMount() {
            // eslint-disable-next-line no-undef
            const DirectionsService = new google.maps.DirectionsService();
            DirectionsService.route({
                // eslint-disable-next-line no-undef
                origin: new google.maps.LatLng(40.191680, 44.466493),
                // eslint-disable-next-line no-undef
                destination: new google.maps.LatLng(40.201680, 44.466493),
                // eslint-disable-next-line no-undef
                travelMode: google.maps.TravelMode.WALKING,
            }, (result, status) => {
                // eslint-disable-next-line no-undef
                if (status === google.maps.DirectionsStatus.OK) {
                    this.setState({
                        directions: result,
                    });
                } else {
                    console.error(`error fetching directions ${result}`);
                }
            });
        }
    })
)(props =>
    <GoogleMap
        defaultZoom={12}
        defaultCenter={props.pathCoordinates[0]}
    >
        {props.pathCoordinates && <Polyline
            path={props.pathCoordinates}
            options={{
                geodesic: true,
                strokeColor: "#FF2D00",
                strokeOpacity: 1.0,
                strokeWeight: 2,
                icons: [
                    {
                        icon: {
                            // eslint-disable-next-line no-undef
                            path: google.maps.SymbolPath.CIRCLE,
                            strokeOpacity: 1,
                            scale: 8,
                            strokeColor: "#00F",
                        },
                        offset: "0%"
                    },
                    {
                        icon: {
                            // eslint-disable-next-line no-undef
                            path: google.maps.SymbolPath.CIRCLE,
                            strokeOpacity: 1,
                            scale: 8,
                            strokeColor: "#E82",
                        },
                        offset: "100%"
                    },
                ],
            }}
        />}
    </GoogleMap>);

export default MapUserTrip;



// WEBPACK FOOTER //
// ./src/views/lib/components/maps/trip-map.js